export { default } from './Card';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Card/index.js
// module id = 577
// module chunks = 121